export const skinCodes = [
    {id:1 , value:"skin1"},
    {id:2 , value:"skin2"},
    {id:3 , value:"skin3"},
    // {id:4 , value:"skin4"},
    // {id:5 , value:"skin5"},
    {id:6 , value:"skin6"},
    // {id:7 , value:"skin7"},
    // {id:8 , value:"skin8"},
] 